import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface INumberBoxProps {
	name: string;
	value: number;
	onValueChanged: (value: number) => void;
	label?: string;
	error?: string;
	sizeClass?: 'xs' | 'sm' | 'md' | 'lg';
	helpBlock?: string;
	placeholder?: string;
	labelSmall?: boolean;
	isDisabled?: boolean;
	hasValid?: boolean;
}

export const NumberBox = (props: INumberBoxProps) => {
	const { value, error, name, label, sizeClass, isDisabled, helpBlock, labelSmall, hasValid, placeholder, onValueChanged } = props;
	const showError = !!error;
	return (
		<div className="space-y-2">
			{label && (
				<Label htmlFor={name} className={cn(labelSmall && "text-xs")}>
					{label} {hasValid && <span className='text-destructive'>(*)</span>}
				</Label>
			)}
			<div className="relative">
				<Input
					id={name}
					type='number'
					name={name}
					value={value ?? ''}
					disabled={isDisabled}
					placeholder={placeholder}
					onChange={(e) => onValueChanged(parseInt(e.target.value || '0', 10))}
					className={cn(showError && "border-destructive")}
				/>
			</div>
			{showError && <p className="text-sm font-medium text-destructive">{error}</p>}
			{helpBlock && <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{ __html: helpBlock }} />}
		</div>
	);
};
